export default "__VITE_ASSET__ju4OYuOf__"